import { ShoppingBag, Trophy } from 'lucide-react'
import { cx } from '@/lib/cx'
import { DecorationsSection } from '../settings/DecorationsSection'
import { AchievementsSection } from '../settings/AchievementsSection'
import { MobileBack } from '@/components/MobileBack'
import chatStyles from '../ChatView.module.css'
import styles from './CollectionPage.module.css'

/**
 * Магазин и достижения на главной, рядом с «Друзьями»: те же разделы, что в настройках, только на
 * виду. Заголовок — в шапке, как у других страниц.
 */
export function CollectionPage({ page }: { page: 'shop' | 'achievements' }) {
  const shop = page === 'shop'
  const title = shop ? 'Магазин' : 'Достижения'
  const Icon = shop ? ShoppingBag : Trophy
  return (
    <main className={chatStyles.chat} aria-label={title}>
      <header className={cx(chatStyles.header, styles.header)}>
        <MobileBack label="К списку бесед" />
        <Icon size={24} className={chatStyles.hash} />
        <h1 className={chatStyles.title}>{title}</h1>
      </header>
      <div className={cx(styles.scroll, 'scroller')}>
        <div className={styles.inner}>{shop ? <DecorationsSection page /> : <AchievementsSection page />}</div>
      </div>
    </main>
  )
}
